export const AccountingReportPage = () => {
  return (
    <div>
      Pour obtenir l'export comptable, cliquez sur le bouton "Exporter" en haut
      à droite de cette page.
    </div>
  );
};
